import "./Stepper.css";
import "./RegUsa.css";
import React, { useState } from "react";
import PdfViewer from "./PdfViewer";

import { RegistroUsuario } from "./RegistroUsuario";
import { useTranslation } from "react-i18next";

function Stepper() {
  const [step, setStep] = useState(1);
  const [agreed, setAgreed] = useState(false);

  const handleNext = () => {
    setStep(step + 1);
  };

  const handlePrev = () => {
    setStep(step - 1);
  };

  const handleAgree = () => {
    setAgreed(!agreed);
  };

  const [t] = useTranslation("global")

  const steps = [t("registroUser.paso-terminos"), t("registroUser.paso-datos")];

  return (
    <>
      {/* Encabezado */}
      <div className="reg-header">
        <h1 className="reg-header__title">{t("registroUser.titulo")}</h1>
        <p className="reg-header__sub">
          {step === 1 ? t("registroUser.subtitulo-1") : t("registroUser.step2-h2")}
        </p>
      </div>

      {/* Indicador de pasos */}
      <ol className="reg-steps">
        {steps.map((label, index) => {
          const number = index + 1;
          const estado = step > number ? "done" : step === number ? "active" : "todo";
          return (
            <li
              key={label}
              className={`reg-step reg-step--${estado}`}
              aria-current={estado === "active" ? "step" : undefined}
            >
              <span className="reg-step__circle">
                {estado === "done" ? <i className="fa-solid fa-check" aria-hidden="true"></i> : number}
              </span>
              <span className="reg-step__label">{label}</span>
            </li>
          );
        })}
      </ol>

      {step === 1 && (
        <div className="reg-card">
          <div className="reg-section">
            <h2 className="reg-section__title">
              <i className="fa-solid fa-file-lines" aria-hidden="true"></i>
              {t("registroUser.step1-h2")}
            </h2>
            <div className="reg-pdf">
              <PdfViewer />
            </div>
            <label className="reg-agree">
              <input
                type="checkbox"
                checked={agreed}
                onChange={handleAgree}
              />
              <span>{t("registroUser.step1-checkbox")}</span>
            </label>
          </div>
          <div className="reg-actions">
            <button
              type="button"
              className="reg-btn reg-btn--primary"
              disabled={!agreed}
              onClick={handleNext}
            >
              {t("registroUser.step1-siguiente")}
            </button>
          </div>
        </div>
      )}

      {step === 2 && (
        <div className="reg-card">
          <RegistroUsuario onBack={handlePrev} />
        </div>
      )}
    </>
  );
}

export default Stepper;
